import { Component, ViewEncapsulation } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { NavbarComponent } from '../../../../../shared/components/navbar/navbar.component';
import { MenuComponent } from '../../../../../shared/components/menu/menu.component';
import { JourneyStepperComponent } from '../journey-stepper/journey-stepper.component';
import { JourneyFooterComponent } from '../journey-footer/journey-footer.component';
import { JourneyStep, journeyStepOf, journeyTitle } from '../../data/journey-steps';

interface OnboardingHeaderVm {
  step: JourneyStep | null;
  title: string;
}

/** Shell of /solicitud/*: site navbar, header title + stepper from the route `data` (PDF 3.3) and the journey footer, in Poppins. */
@Component({
  selector: 'app-onboarding-layout',
  standalone: true,
  imports: [NgIf, AsyncPipe, RouterOutlet, NavbarComponent, MenuComponent, JourneyStepperComponent, JourneyFooterComponent],
  templateUrl: './onboarding-layout.component.html',
  styleUrls: ['./onboarding-layout.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class OnboardingLayoutComponent {
  toogle = false;

  readonly vm$: Observable<OnboardingHeaderVm> = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    startWith(null),
    map(() => {
      const step = journeyStepOf(this.route.snapshot);
      return { step, title: step ? journeyTitle(step) : '' };
    }),
  );

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}
}
